<template>
    <b-modal id="register-form-modal" title="패키징 타입 등록" @ok="handleSubmit">
      <b-form @submit.stop.prevent="handleSubmit">
        <b-form-group label="이름" label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="form.name"
            required
          ></b-form-input>
        </b-form-group>
  
        <b-form-group label="타입코드" label-for="typecode-input">
          <b-form-input
            id="typecode-input"
            v-model="form.typeCode"
            required
          ></b-form-input>
        </b-form-group>
  
        <b-form-group label="사이즈" label-for="size-input">
          <b-form-input
            id="size-input"
            v-model="form.dimensions"
            required
          ></b-form-input>
        </b-form-group>
  
        <b-form-group label="수량" label-for="quantity-input">
          <b-form-input
            id="quantity-input"
            type="number"
            v-model="form.quantity"
            required
          ></b-form-input>
        </b-form-group>
  
        <b-form-group label="단위" label-for="unit-input">
          <b-form-input
            id="unit-input"
            v-model="form.uom"
            required
          ></b-form-input>
        </b-form-group>
  
        <b-form-group label="이미지" label-for="image-input">
          <b-form-file
            id="image-input"
            v-model="form.image"
          ></b-form-file>
        </b-form-group>
      </b-form>
    </b-modal>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          typeCode: '',
          dimensions: '',
          quantity: null,
          uom: '',
          image: null,
        }
      };
    },
    methods: {
      handleSubmit() {
        this.$emit('submit', this.form);
        this.$bvModal.hide('register-form-modal');
      },
      resetForm(initialData) {
      this.form = {
          name: '',
          typeCode: '',
          dimensions: '',
          quantity: null,
          uom: '',
          image: null,
        };
    }
    }
  };
  </script>
  